/** @format */
import getNextConfig from 'next/config';

// eslint-disable-next-line boundaries/element-types, boundaries/entry-point -- Touch and change -- We shouldn't import from client into common
import { PublicRuntimeConfig } from '@toucan/client/global/nextjs/config/types';

/** @format */

// eslint-disable-next-line @mpb-com/mpb/require-types-file -- Legacy code: do not use as an example.
export type WindowWithToucanConfig = Window & {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- Legacy code: do not use as an example.
    __TOUCAN_RUNTIME_CONFIG__?: any;
};

type Config = { publicRuntimeConfig: PublicRuntimeConfig };

export function getConfig(): Config {
    const isServer = typeof window === 'undefined';
    // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing, @typescript-eslint/no-unsafe-assignment -- Legacy code: do not use as an example.
    const { publicRuntimeConfig } = getNextConfig() || {};

    if (isServer) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment -- Legacy code: do not use as an example.
        return { publicRuntimeConfig };
    }

    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment -- Legacy code: do not use as an example.
    const clientConfig =
        (window as WindowWithToucanConfig)?.__TOUCAN_RUNTIME_CONFIG__ ?? {};

    return {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment -- Legacy code: do not use as an example.
        publicRuntimeConfig: {
            ...publicRuntimeConfig,
            ...clientConfig,
        },
    };
}
